module.exports = __webpack_public_path__ + "static/media/wind_alert.7319bfc1.png";